import { Box, Flex } from '@chakra-ui/react';
import { Avatar, Text } from '@kula-ai/components';
import type {
  JobTeamTabProps,
  PersonRowProps,
  TeamSectionProps,
} from './JobTeamTab.types';

const PersonRow = ({ user }: PersonRowProps) => (
  <Flex align="center" gap="10px">
    <Avatar src={user.avatarUrl} name={user.name} size="sm" alt={user.name} />
    <Text variant="span" className="text-secondary-900 font-medium">
      {user.name}
    </Text>
  </Flex>
);

const TeamSection = ({ label, members }: TeamSectionProps) => (
  <Flex direction="column" gap="6px">
    <Text
      variant="small"
      className="text-secondary-400 uppercase tracking-wide"
    >
      {label}
    </Text>
    {members.length === 0 ? (
      <Text variant="small" className="text-secondary-400">
        Not assigned yet.
      </Text>
    ) : (
      <Flex direction="column" gap="6px">
        {members.map((user) => (
          <PersonRow key={user.id} user={user} />
        ))}
      </Flex>
    )}
  </Flex>
);

export const JobTeamTab = ({ data }: JobTeamTabProps) => (
  <Flex direction="column" gap="16px">
    <TeamSection
      label="Hiring manager"
      members={data.hiringManager ? [data.hiringManager] : []}
    />
    <Box borderTop="1px solid" borderColor="secondary-100" pt="16px">
      <TeamSection label="Recruiters" members={data.recruiters} />
    </Box>
    <Box borderTop="1px solid" borderColor="secondary-100" pt="16px">
      <TeamSection label="Interviewers" members={data.interviewers} />
    </Box>
  </Flex>
);
